import IntegralCenter from './src/components/IntegralCenter'
import _Vue from 'vue'

IntegralCenter.install = Vue => {
  if (!Vue) {
    window.Vue = Vue = _Vue
  }
  Vue.component(IntegralCenter.name, IntegralCenter)
}
export default IntegralCenter;



// WEBPACK FOOTER //
// ./index.js